import Button, { ButtonType } from "../../components/Button";
import DataTable from "../../components/DataTable";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import {
	getAccessLevelLabel,
	getLastLoginDisplayValue
} from "./ViewCustomer.helpers";

const CustomerUsersPanel = ({
	users,
	onAddUser,
	onEditUser
}) => {
	const editButtonTemplate = (rowData) => {
		const isPendingCreate = rowData?.IsPendingCreate === true;

		return (
			<Button
				type={ButtonType.Primary}
				icon={faPenToSquare}
				label={"Edit"}
				onClick={() => onEditUser(rowData)}
				disabled={isPendingCreate}
			/>
		);
	};

	const columns = [
		{
			field: "FirstName",
			headerName: "First Name"
		},
		{
			field: "LastName",
			headerName: "Last Name"
		},
		{
			field: "Username",
			headerName: "Username"
		},
		{
			field: "RoleId",
			headerName: "Access Level",
			valueGetter: (rowData) => getAccessLevelLabel(rowData),
			style: { minWidth: "160px" }
		},
		{
			field: "LastLoginDate",
			headerName: "Last Login",
			valueGetter: (rowData) => getLastLoginDisplayValue(rowData)
		},
		{
			field: "LastReminderDate",
			headerName: "Registration Invite sent",
			valueGetter: (rowData) => rowData.LastReminderDate
		},
		{
			headerName: "",
			valueGetter: editButtonTemplate,
			style: { minWidth: "120px" },
			sortable: false,
			removeHeaderFromMobile: true
		}
	];

	return (
		<>
			<h4>Users</h4>

			<div className="add-user">
				<Button
					type={ButtonType.Primary}
					className="add-user-btn"
					label="Add New User +"
					onClick={onAddUser}
				/>
			</div>

			<DataTable
				columns={columns}
				rows={users}
				columnIdName="RowKey"
				className="p-datatable-sm"
			/>

			<div className="add-user">
				<Button
					type={ButtonType.Primary}
					className="add-user-btn"
					label="Add New User +"
					onClick={onAddUser}
				/>
			</div>
		</>
	);
};

export default CustomerUsersPanel;